// @flow

import * as React from "react";
import { ReactForm, ReactFormField } from "@adrenalin/react-form";

type PropsType = {
    action: ?string,
    hiddenInputs: ?any,
};

const TermsAndConditionForm = (props: PropsType): React.Node => {
    return (
        <ReactForm pageSubmit method="POST" action={props.action || ""}>
            <ReactFormField
                type="checkbox"
                required={true}
                label="I agree to the legal terms and conditions of use."
                name="agree-terms"
            />

            <button type="submit" className="button button--wide">
                Continue
            </button>

            {props.hiddenInputs || null}
        </ReactForm>
    );
};

export default TermsAndConditionForm;
